import api from '@/libs/axios'

export default {
  async getCategoryList(params) {
    let response = await api.get('/admin/item-sets', {
      params,
    })
    return response.data.type === 'DATA' ? response.data.data.list : []
  },
  async updateCategory(payload) {
    let response = await api.put('/admin/item-sets', payload)
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/item-sets', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/item-sets', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/item-sets/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async update(payload) {
    let response = await api.put('/admin/item-sets', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/item-sets', {
      data: payload,
    })
    return response
  },
  async getAll() {
    const response = await api.get('/admin/item-sets/all')
    return response.data.data || null
  }

}
